import { i18n } from '../i18n'

export default {
  path: '/evaluations',
  name: '',
  component: () => import(/* webpackChunkName: 'evaluations' */ '../views/Evaluations.vue'),
  children: [
    {
      path: '',
      name: 'Evaluations',
      component: () => import(/* webpackChunkName: 'evaluations-table' */ '../components/evaluations/EvaluationsTable.vue'),
      meta: {
        title: i18n.global.t('default.home.title') + ' | UG',
        requiresAuth: true,
        uri:'/evaluations'
      }
    },
    {
      path: 'percentage-statistics',
      name: 'PercentageStatistics',
      component: () => import(/* webpackChunkName: 'percentage-statistics' */ '../views/Statistics/PercentageStatistics'),
      meta: {
        title: i18n.global.t('default.statistics.percentage-statistics') + ' | UG',
        requiresAuth: true,
        uri:'/evaluations/percentage-statistics'
      }
    },
    {
      path: 'average-statistics',
      name: 'AverageStatistics',
      component: () => import(/* webpackChunkName: 'average-statistics' */ '../views/Statistics/AverageStatistics'),
      meta: {
        title: i18n.global.t('default.statistics.average-statistics') + ' | UG',
        requiresAuth: true,
        uri:'/evaluations/average-statistics'
      }
    },
    {
      path: 'exams/:group/:examNumberId',
      name: 'ExamEvaluations',
      component: () => import(/* webpackChunkName: 'exam-evaluations' */ '../views/ExamEvaluations.vue'),
      meta: {
        title: i18n.global.t('default.evaluations.check-exams') + ' | UG',
        requiresAuth: true,
         uri:'/evaluations'
        
      }
    },
    {
      path: 'exams/:group/details/:studentTicketId/:examScheduleId',
      name: 'ExamEvaluationDetails',
      component: () => import(/* webpackChunkName: 'exam-evaluation-details' */ '../views/ExamEvaluationDetails.vue'),
      meta: {
        title: i18n.global.t('default.evaluations.check-exams') + ' | UG',
        requiresAuth: true,
         uri:'/evaluations'
        
      }
    },
    {
      path: ':group/:componentRequestID/:week?',
      name: 'GroupEvaluations',
      component: () => import(/* webpackChunkName: 'group-evaluations' */ '../components/evaluations/GroupEvaluations.vue'),
      meta: {
        requiresAuth: true,
        title: i18n.global.t('default.evaluations.title') + ' | UG',
         uri:'/evaluations'
        
      }
    }
  ]
}
